import { render, staticRenderFns } from "./zhongzhengyijia.vue?vue&type=template&id=35ae70c2"
import script from "./zhongzhengyijia.vue?vue&type=script&lang=js"
export * from "./zhongzhengyijia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports